// extracted by mini-css-extract-plugin
module.exports = {"copyToClipboard":"CopyToClipboardPopup_copyToClipboard__8Foz0","active":"CopyToClipboardPopup_active__4Km__"};